export default __webpack_public_path__ + "static/media/newsletter.48d74f14.svg";